import React, { useState } from 'react';
import { SxStyle } from '../../../../types';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useSnackbar } from 'notistack';
import isCidr from 'is-cidr';
import { IpRangeArenaConfig } from '../types';
import { useStringsContext } from '../../../../contexts/strings';

const styles: SxStyle = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  saveButton: {
    marginTop: '10px',
    marginRight: '10px',
  },
};

export default function NetworkConfiguratorForm({
  ipRangeArenaConfig,
  submitConfig,
}: {
  ipRangeArenaConfig: IpRangeArenaConfig;
  submitConfig: (config: IpRangeArenaConfig) => void;
}) {
  const { strings } = useStringsContext();
  const { enqueueSnackbar } = useSnackbar();
  const [arenaNameInput, setArenaName] = useState(ipRangeArenaConfig.arena);
  const [ipRangeInput, setIpRange] = useState(ipRangeArenaConfig.ipRange);

  const onChangeArenaName = (e: any) => {
    setArenaName(e.target.value);
  };

  const resetForm = () => {
    setArenaName(ipRangeArenaConfig.arena);
    setIpRange(ipRangeArenaConfig.ipRange);
  };

  const onChangeIpRangeInput = (e: any) => {
    setIpRange(e.target.value);
  };

  const saveConfiguration = () => {
    const validIpRange = isCidr(ipRangeInput);

    if (validIpRange) {
      const configuration = {
        arena: arenaNameInput,
        ipRange: ipRangeInput,
      };

      submitConfig(configuration);
    }

    if (!validIpRange) {
      enqueueSnackbar(strings.validations.validIPRange, {
        variant: 'error',
      });
    }
  };

  const showSaveAndResetButton =
    arenaNameInput !== ipRangeArenaConfig.arena || ipRangeInput !== ipRangeArenaConfig.ipRange;

  return (
    <>
      <Grid container>
        <Grid item container>
          <Grid item paddingRight={2}>
            <TextField
              id="outlined-full-width"
              label={strings.wifi.headerArena}
              fullWidth
              margin="normal"
              variant="outlined"
              value={arenaNameInput}
              onChange={onChangeArenaName}
            />
          </Grid>
          <Grid item>
            <TextField
              id="outlined-full-width"
              label={strings.wifi.headerRanges}
              fullWidth
              margin="normal"
              variant="outlined"
              value={ipRangeInput}
              onChange={onChangeIpRangeInput}
            />
          </Grid>
        </Grid>
        <Grid item container>
          <Grid item>
            <Button
              sx={styles.saveButton}
              variant="contained"
              color="primary"
              onClick={() => resetForm()}
              disabled={!showSaveAndResetButton}
            >
              {strings.actions.cancel}
            </Button>
          </Grid>
          <Grid item>
            <Button
              sx={styles.saveButton}
              variant="contained"
              color="primary"
              onClick={saveConfiguration}
              disabled={!showSaveAndResetButton}
            >
              {strings.actions.save}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
